import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=10c5cd6f&scoped=true&lang=html&"
import script from "./terms.vue?vue&type=script&lang=js&"
export * from "./terms.vue?vue&type=script&lang=js&"
import style0 from "./terms.vue?vue&type=style&index=0&id=10c5cd6f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5cd6f",
  null
  
)

component.options.__file = "terms.vue"
export default component.exports